import { render } from "./MyMemberFavorites.vue?vue&type=template&id=d74650e4"
import script from "./MyMemberFavorites.vue?vue&type=script&lang=js"
export * from "./MyMemberFavorites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__